// extracted by css-extract-rspack-plugin
export default {"root":"e3iH4"};